import { useMemo } from "react";
import { dollarFormat } from "../../../../utils";
import { useApi } from "../../../../swr/useApi";
import { loyaltyService } from "../../../api_client";
import { useQuotations } from "../../hooks/useQuotations";
import { deriveQuotationStatus, getExpiryInfo } from "../../utils/quotation-status";
import { AccentStatCard } from "../../../../components/common/accent-stat-card";
import { GatedPrice } from "../../../../components/common/gated-price";
import type { LoyaltyPointsResponseDto } from "../../../../api";

export function QuotationsStats() {
  const { data: pendingResp } = useQuotations("pending", { pageSize: 50 });
  const { data: loyaltyResp } = useApi<LoyaltyPointsResponseDto>(
    "quotations-stats-loyalty-summary",
    () => loyaltyService.getMyLoyaltyPoints({ pageSize: 1 }),
  );

  const { activeCount, expiringSoon, totalQuoted } = useMemo(() => {
    const items = pendingResp?.data ?? [];
    let active = 0;
    let expiring = 0;
    let total = 0;
    for (const q of items) {
      const status = deriveQuotationStatus(q.state, q.validityDate);
      if (status !== "pending") continue;
      active += 1;
      total += q.amountTotal ?? 0;
      const exp = getExpiryInfo(q.validityDate, q.createDate);
      if (exp.isUrgent) expiring += 1;
    }
    return {
      activeCount: pendingResp?.meta?.totalCount ?? active,
      expiringSoon: expiring,
      totalQuoted: total,
    };
  }, [pendingResp]);

  const loyaltyPoints = loyaltyResp?.meta?.activePoints ?? 0;

  return (
    <div className="flex gap-4 max-md:grid max-md:grid-cols-2 max-md:gap-3">
      <AccentStatCard label="Active Quotes" value={activeCount.toLocaleString()} accent="green" className="flex-1" />
      <AccentStatCard label="Expiring soon" value={expiringSoon.toLocaleString()} accent="amber" className="flex-1" />
      <AccentStatCard label="Total quoted" value={<GatedPrice>{dollarFormat(totalQuoted, "QAR")}</GatedPrice>} accent="amber" className="flex-1" />
      <AccentStatCard label="Loyalty points" value={`${loyaltyPoints.toLocaleString()} pts`} accent="green" className="flex-1" />
    </div>
  );
}
